import React from 'react';
import parse from "html-react-parser";

export function getAnalytics(analytics){
  const doc = {
    head: [],
    body: []
  };
  analytics?.forEach(({codes}) => {
    return codes.forEach(({code, place}, index) => {
      const notCommentsCode = code.replace(/\<!--(.|\n)*?-->/g, '');
      const fragment = <React.Fragment key={index}>{parse(notCommentsCode)}</React.Fragment>
      place.includes('HEAD') ? doc.head.push(fragment) : doc.body.push(fragment)
    })
  })
  return doc
}
